import {
  GetAccountRequestAction,
  GetAccountSuccessAction,
  GetAccountFailureAction,
  Account,
  UpdateAccountRequestAction,
  UpdateAccountSuccessAction,
  UpdateAccountFailureAction,
  GetAccountsRequestAction,
  GetAccountsSuccessAction,
  GetAccountsFailureAction,
  SwitchAccountAction,
  CreateCloudApiRequestAction,
  CreateCloudApiSuccessAction,
  AssignMarketplaceAccountIdRequestAction,
  SetProductTypeSuccessAction,
  SetProductTypeFailureAction,
  PollAccountUntilMPIsActiveRequestAction
} from './account.types';

export const getAccountRequest = (): GetAccountRequestAction => ({
  type: 'GET_ACCOUNT_REQUEST'
});

export const getAccountSuccess = (payload: Account): GetAccountSuccessAction => ({
  type: 'GET_ACCOUNT_SUCCESS',
  payload
});

export const getAccountFailure = (error: string, status: number): GetAccountFailureAction => ({
  type: 'GET_ACCOUNT_FAILURE',
  payload: { error, status }
});

export const updateAccountRequest = (payload: {
  formPayload: Account;
  finallyCallback: () => void;
}): UpdateAccountRequestAction => ({
  type: 'UPDATE_ACCOUNT_REQUEST',
  payload
});

export const updateAccountSuccess = (payload: Account): UpdateAccountSuccessAction => ({
  type: 'UPDATE_ACCOUNT_SUCCESS',
  payload
});

export const updateAccountFailure = (payload: string): UpdateAccountFailureAction => ({
  type: 'UPDATE_ACCOUNT_FAILURE',
  payload
});

export const getAccountsRequest = (): GetAccountsRequestAction => ({
  type: 'GET_ACCOUNTS_REQUEST'
});

export const getAccountsSuccess = (payload: Account[]): GetAccountsSuccessAction => ({
  type: 'GET_ACCOUNTS_SUCCESS',
  payload
});

export const getAccountsFailure = (error: string): GetAccountsFailureAction => ({
  type: 'GET_ACCOUNTS_FAILURE',
  payload: error
});

export const switchAccount = (accountId: number): SwitchAccountAction => ({
  type: 'SWITCH_ACCOUNT',
  payload: accountId
});

export const createCloudApiRequest = (): CreateCloudApiRequestAction => ({
  type: 'CREATE_ACCOUNT_API_REQUEST'
});

export const createCloudApiSuccess = (payload: string): CreateCloudApiSuccessAction => ({
  type: 'CREATE_ACCOUNT_API_SUCCESS',
  payload
});

export const assignMarketplaceAccountIdRequest = (
  payload: AssignMarketplaceAccountIdRequestAction['payload']
): AssignMarketplaceAccountIdRequestAction => ({
  type: 'POST_MARKETPLACE_ACCOUNT_ID_REQUEST',
  payload
});

export const assignMarketplaceAccountIdFailure = (error: string) => ({
  type: 'POST_MARKETPLACE_ACCOUNT_ID_FAILURE',
  payload: error
});

export const pollAccountUntilMPIsActiveRequest = (
  payload: PollAccountUntilMPIsActiveRequestAction['payload']
): PollAccountUntilMPIsActiveRequestAction => ({
  type: 'POLL_ACCOUNT_UNTIL_MP_ACTIVE',
  payload
});

export const setProductTypeSuccessAction = (
  productType: ProductType
): SetProductTypeSuccessAction => ({
  type: 'SET_PRODUCT_TYPE_SUCCESS',
  payload: productType
});

export const setProductTypeFailureAction = (): SetProductTypeFailureAction => ({
  type: 'SET_PRODUCT_TYPE_FAILURE'
});
